import {
    FETCH_USER_ASSETS_FAILURE,
    FETCH_USER_ASSETS_REQUEST,
    FETCH_USER_ASSETS_SUCCESS,
    FETCH_USER_PNL_EXPECTED_FAILURE,
    FETCH_USER_PNL_EXPECTED_REQUEST,
    FETCH_USER_PNL_EXPECTED_SUCCESS,
    FETCH_USER_PNL_FAILURE,
    FETCH_USER_PNL_REQUEST,
    FETCH_USER_PNL_SUCCESS,
} from './constants';
import { UserAssetsData, UserPnLData, UserPnLExpectedData } from './types';

export interface FetchUserAssetsRequestAction {
    type: typeof FETCH_USER_ASSETS_REQUEST;
}

export interface FetchUserAssetsSuccessAction {
    type: typeof FETCH_USER_ASSETS_SUCCESS;
    payload: UserAssetsData;
}

export interface FetchUserAssetsFailureAction {
    type: typeof FETCH_USER_ASSETS_FAILURE;
    payload: any;
}
export interface FetchUserPnLRequestAction {
    type: typeof FETCH_USER_PNL_REQUEST;
}

export interface FetchUserPnLSuccessAction {
    type: typeof FETCH_USER_PNL_SUCCESS;
    payload: UserPnLData;
}

export interface FetchUserPnLFailureAction {
    type: typeof FETCH_USER_PNL_FAILURE;
    payload: any;
}
export interface FetchUserPnLExpectedRequestAction {
    type: typeof FETCH_USER_PNL_EXPECTED_REQUEST;
}

export interface FetchUserPnLExpectedSuccessAction {
    type: typeof FETCH_USER_PNL_EXPECTED_SUCCESS;
    payload: UserPnLExpectedData[];
}

export interface FetchUserPnLExpectedFailureAction {
    type: typeof FETCH_USER_PNL_EXPECTED_FAILURE;
    payload: any;
}

export type UserAssetsActions =
    | FetchUserAssetsRequestAction
    | FetchUserAssetsSuccessAction
    | FetchUserAssetsFailureAction
    | FetchUserPnLRequestAction
    | FetchUserPnLSuccessAction
    | FetchUserPnLFailureAction
    | FetchUserPnLExpectedRequestAction
    | FetchUserPnLExpectedSuccessAction
    | FetchUserPnLExpectedFailureAction;

export const fetchUserAssetsRequest = (): FetchUserAssetsRequestAction => ({
    type: FETCH_USER_ASSETS_REQUEST,
});

export const fetchUserAssetsSuccess = (userAssetsDatas: UserAssetsData): FetchUserAssetsSuccessAction => ({
    type: FETCH_USER_ASSETS_SUCCESS,
    payload: userAssetsDatas,
});

export const fetchUserAssetsFailure = (error: any): FetchUserAssetsFailureAction => ({
    type: FETCH_USER_ASSETS_FAILURE,
    payload: error,
});
export const fetchUserPnLRequest = (): FetchUserPnLRequestAction => ({
    type: FETCH_USER_PNL_REQUEST,
});

export const fetchUserPnLSuccess = (userPnLDatas: UserPnLData): FetchUserPnLSuccessAction => ({
    type: FETCH_USER_PNL_SUCCESS,
    payload: userPnLDatas,
});

export const fetchUserPnLFailure = (error: any): FetchUserPnLFailureAction => ({
    type: FETCH_USER_PNL_FAILURE,
    payload: error,
});
export const fetchUserPnLExpectedRequest = (): FetchUserPnLExpectedRequestAction => ({
    type: FETCH_USER_PNL_EXPECTED_REQUEST,
});

export const fetchUserPnLExpectedSuccess = (userPnLExpectedDatas: UserPnLExpectedData[]): FetchUserPnLExpectedSuccessAction => ({
    type: FETCH_USER_PNL_EXPECTED_SUCCESS,
    payload: userPnLExpectedDatas,
});

export const fetchUserPnLExpectedFailure = (error: any): FetchUserPnLExpectedFailureAction => ({
    type: FETCH_USER_PNL_EXPECTED_FAILURE,
    payload: error,
});
